import React from 'react';
import {ArticleDetail} from './ArticleDetail';
import {useIsQuickView} from '@aboutyou/logic-components';
import {QuickViewArticle} from '../QuickViewArticlePage/QuickViewArticle';

export const ArticleDetailSwitch = () => {
  const isQuickView = useIsQuickView();
  if (isQuickView) {
    return (
      <>
        <QuickViewArticle isQuickView={isQuickView} />
        {/* the span will be used within the `useIsQuickView` handler to fix potential caching issues to avoid hydration issues */}
        <span data-quick-view-enabled="true" />
      </>
    );
  }

  return (
    <>
      <ArticleDetail />
      <span data-quick-view-enabled="false" />
    </>
  );
};
